import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const DistributeHorizontal = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <path
            fillRule="evenodd"
            d="M3 18L3 2L4.35211 2L4.35211 18H3ZM15.3944 18L15.3944 2L16.7465 2L16.7465 18H15.3944ZM8.18308 4.92962L11.5634 4.92962L11.5634 15.0705H8.18308L8.18308 4.92962Z"
            fill={color}
          />
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

DistributeHorizontal.displayName = "DistributeHorizontal";

export { DistributeHorizontal };
